import { createContext } from "react";
import  { UserShow } from "../models/User";
interface UserContextType {
    user: UserShow | undefined;
  }

const UserContext = createContext<UserContextType >({
    user: undefined
  });


export default UserContext;